<template>
  <div id="app" class="min-h-screen bg-slate-900">
    <!-- Layout com autenticação -->
    <div v-if="authStore.isAuthenticated" class="min-h-screen">
      <!-- Header -->
      <AppHeader />
      
      <!-- Main Content -->
      <!-- pb no celular: espaco para a barra de abas fixa nao cobrir o
           conteudo (inclui a area segura do iPhone) -->
      <main class="pt-16 pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
        <RouterView />
      </main>

      <!-- Abas fixas embaixo, so no celular -->
      <BottomNav />
    </div>
    
    <!-- Tela de login -->
    <div v-else class="min-h-screen flex items-center justify-center">
      <RouterView />
    </div>
    
    <!-- Notifications Global -->
    <NotificationContainer />
    
    <!-- Loading Global -->
    <LoadingOverlay v-if="uiStore.isLoading" :message="uiStore.loadingMessage" />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUIStore } from '@/stores'
import { useTunnelStore } from '@/stores'
import AppHeader from '@/components/layout/AppHeader.vue'
import BottomNav from '@/components/layout/BottomNav.vue'
import NotificationContainer from '@/components/ui/NotificationContainer.vue'
import LoadingOverlay from '@/components/ui/LoadingOverlay.vue'

const authStore = useAuthStore()
const uiStore = useUIStore()
const tunnelStore = useTunnelStore()

onMounted(() => {
  // Tentar restaurar sessão do usuário
  authStore.initializeAuth()
  
  // Conectar WebSocket dos túneis se autenticado
  if (authStore.isAuthenticated) {
    tunnelStore.initializeWebSocket()
  }
})
</script>